import { TeamMemberRole } from '@api'
import { useUnit } from 'effector-react'

import PlusIcon from '@/assets/icons/icon-plus.svg'
import { Button } from '@/components/ui/button.tsx'
import { SearchInput } from '@/components/ui/search-input.tsx'
import { $account } from '@/models/account.ts'

interface Props {
  onInviteMembers: () => void
  onFilterChange: (query: string) => void
}

export const HeaderButtons = ({ onInviteMembers, onFilterChange }: Props) => {
  const account = useUnit($account)

  return (
    <div className="flex items-center gap-2">
      <SearchInput
        placeholder="Enter Name"
        onInputChange={onFilterChange}
        testId="search-input"
      />
      {account?.memberRole !== TeamMemberRole.MEMBER && (
        <Button
          onClick={onInviteMembers}
          className="flex gap-1"
          testId="invite-members-button"
        >
          <PlusIcon
            width={25}
            height={25}
          />
          Invite Members
        </Button>
      )}
    </div>
  )
}
